import { Button, Col, Form, Input, message, Row } from "antd";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./sign-in.scss";

import { Formik } from "formik";
import AvocadoAdmin from "../../../api/avocado.admin";
import AvocadoModerator from "../../../api/avocado.moderator";
import { UserContext } from "../../../context/userContext";

export default class SignIn extends Component<any, any> {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
    };
  }

  async setPartner(user) {
    try {
      let result = await AvocadoAdmin.getBrandById(
        null,
        user.permissions.scope
      );
      sessionStorage.setItem("avocado-partner", JSON.stringify(result.body));
    } catch (error) {
      sessionStorage.clear();
      message.error("Error getting brand");
    }
  }

  componentDidMount() {
    const [userState, setUser] = this.context;
    if (userState) {
      if (userState.permissions.role === "admin") {
        this.props.history.push("/admin");
      } else if (userState.permissions.role === "brand") {
        this.props.history.push("/partner");
      } else {
        this.props.history.push("/moderator");
      }
    }
  }
  render() {
    const { history } = this.props;
    const [userState, setUser] = this.context;

    // console.log(userState)
    console.log('shr REACT_APP_OKTA_APP_EMBED_LINK',process.env.REACT_APP_OKTA_APP_EMBED_LINK);
    
    return (
      <React.Fragment>
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          onSubmit={async (values, actions) => {
            console.log({ values, actions });
            actions.setSubmitting(true);
            this.setState({ isSubmitting: true });
            try {
              let result = await AvocadoAdmin.signIn(values);
              if (result.status !== 201) {
                result = await AvocadoModerator.signIn(values);
              }
              console.log('result',result.body);
              
              const { user, token } = result.body;
              sessionStorage.setItem("avocado-user", JSON.stringify(user));
              sessionStorage.setItem("avocado-token", token);
              setUser(user);
              if (user.permissions.role === "wladmin" || user.permissions.role === "admin") {
                history.push("/admin");
              } else if (user.permissions.role === "brand") {
                await this.setPartner(user);
                const brand = JSON.parse(
                  sessionStorage.getItem("avocado-partner")
                );
                if (!brand.hasUpdated) {
                  history.push("/partner/profile");
                } else {
                  history.push("/partner");
                }
              } else if (user.permissions.role === "moderator") {
                history.push("/moderator");
              }
            } catch (error) {
              message.error("Your Email or Password Is Incorrect");
            }
            this.setState({ isSubmitting: false });

            actions.setSubmitting(false);
          }}
        >
          {({
            values,
            handleChange,
            handleSubmit,
            handleBlur,
            handleReset,
            setSubmitting,
            errors,
            touched,
            setFieldValue,
          }) => (
            <Row justify="center" align="middle" className="sign-in-page">
              <Col className="content">
                <Row className="logo">
                  <p
                    style={{ fontSize: 34, color: "white", fontWeight: "bold" }}
                  >
                    SHORELIGHT
                  </p>
                  {/* <img
                    style={{
                      maxWidth: 200,
                    }}
                    alt="Avocado"
                    src={logo}
                  /> */}
                </Row>

                <Row>
                  <Col span={24} className="card inner">
                    <div className="justify-center">
                      <h3 className="text-center">Sign In</h3>
                      <Form
                        onSubmitCapture={handleSubmit}
                        className="inner-row"
                        layout="vertical"
                        colon={false}
                      >
                        <Form.Item label="Email">
                          <Input
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            className="input-with-border"
                          ></Input>
                        </Form.Item>
                        <Form.Item label="Password">
                          <Input
                            className="input-with-border"
                            name="password"
                            onChange={handleChange}
                            value={values.password}
                            type="password"
                          ></Input>
                        </Form.Item>

                        <Button
                          htmlType="submit"
                          type="default"
                          block
                          loading={this.state.isSubmitting}
                        >
                          Sign In
                        </Button>
                        <div className="justify-space-between" style={{padding:'10px'}}>
                          or 
                        </div>

                        <Button
                          htmlType="button"
                          type="primary"
                          block
                          onClick={()=>{
                            // history.push('/verification')
                            window.location.href=process.env.REACT_APP_OKTA_APP_EMBED_LINK
                          }}
                        >
                          Login with OKTA
                        </Button>

                        <div className="text-center inner-row">
                          Forgot Password?{" "}
                          <Link
                            style={{
                              color: "#EC780E",
                              fontWeight: 700,
                            }}
                            to="/forgot-password"
                          >
                            Reset
                          </Link>
                        </div>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}
